export class Result {
  constructor(result, data, message = null, code = null) {
    this.result = result;
    this.data = data;
    this.message = message;
    this.code = code;
  }
  static ok(data) {
    return new Result(true, data);
  }
  static error(message, code = null) {
    return new Result(false, null, message, code);
  }
  isOk() {
    return this.result;
  }
  isError() {
    return !this.result;
  }
  unwrap() {
    if (this.result) {
      return this.data;
    } else {
      throw new Error(this.message);
    }
  }
  unwrapOr(or) {
    return this.result ? this.data : or;
  }
  unwrapOrNull() {
    return this.result ? this.data : null;
  }
}
//# sourceMappingURL=index.js.map
